import src from "IMAGE";
export default { src, width: 1808, height: 371, blurWidth: 0, blurHeight: 0};
